export const get_procedureSos = `
query GetProcedureSos($tenantId: String!, $aziendaId: Int!) {
    getProceduraSos(tenantId: $tenantId, aziendaId: $aziendaId) {
        id
        aziendaId   
        nominativoReferenteSos     
        contributoColleghi
        attivitaStrumentiAnomalie
        prioritaAnomalie
        strumentiSelezione
        partenariati
        soggettiEsterni
        createdOn
        modifiedOn
        createdBy
        modifiedBy
    }
}`;
export const get_procedureSosReport = `
query GetProcedureSosReport($aziendaId: Int!, $userId: String!, $datePrint: String!, $isToBeSaved: Boolean!, $isAllegato: Boolean!) {
    printProceduraSosReport(aziendaId: $aziendaId, userId: $userId, datePrint: $datePrint, isToBeSaved: $isToBeSaved, isAllegato: $isAllegato) {
        response
    }
}`;